import { render, staticRenderFns } from "./explanation.vue?vue&type=template&id=30576052"
import script from "./explanation.vue?vue&type=script&lang=js"
export * from "./explanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports